import dates from "tools/dates";
import proxy from "api/proxy";
import useChildStore from "store/childStore";
import { useWizardStore } from "store/wizardStore";
import { getStorage } from "store/local";

async function getAvailableRooms(arrival, departure) {
  const regexFull =
    /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT([+-]\d{4}) \([A-Za-z\s]+ [A-Za-z]+\)$/;
  const regexISO = /^\d{4}-\d{2}-\d{2}$/;

  const formatDateIfValid = (date, fmtDate2Tryton) => {
    if (regexISO.test(date)) {
      return date;
    } else if (regexFull.test(date)) {
      return fmtDate2Tryton(date);
    } else {
      return null;
    }
  };

  const session = getStorage("ctxSession");
  const arrival_ = formatDateIfValid(arrival, dates.fmtDate2Tryton);
  const departure_ = formatDateIfValid(departure, dates.fmtDate2Tryton);
  const args = {
    start_date: arrival_,
    end_date: departure_,
    shop: session.shop,
    price_list: null,
    oc: null,
  };
  const { data } = await proxy.methodCall({
    model: "hotel.room",
    method: "dap",
    args: [args],
    kwargs: {},
  });
  const dataRooms = data.records.flatMap((item) => item.rooms);
  const roomsAval = dataRooms.map((ro) => ro.id);
  return roomsAval;
}

async function searchAvailableRooms() {
  const { record } = useChildStore.getState();
  const { record: recordWizard, store: storeWizard } =
    useWizardStore.getState();

  const departure_date = recordWizard?.departure_date || record?.departure_date;
  const arrival_date = recordWizard?.arrival_date || record?.arrival_date;
  const product = storeWizard?.product?.id || record?.product.id;
  if (storeWizard?.overbooking) {
    return ["accommodation", "=", product];
  } else {
    const roomsAvalaible = await getAvailableRooms(
      arrival_date,
      departure_date,
    );
    return [
      ["accommodation", "=", product],
      ["id", "in", roomsAvalaible],
    ];
  }
}

const getView = (props) => {
  const editCheckIn = props?.registration_state === "check_in";

  const DictCtxView = {
    model: "hotel.folio",
    // model: "hotel.folio_update.start",
    form_action: ["add", "edit", "delete"],
    table_action: [],
    domain: [],
    orderBy: [["sale_date", "ASC"]],
    limit: 100,
    target: "folio",
    webfields: {
      arrival_date: {
        type: "date_v2",
        readOnly: editCheckIn,
        // withChange: withChangeDate,
      },
      overbooking: {
        type: "boolean",
        translate: true,
        // readOnly: edit,
      },
      departure_date: {
        type: "date_v2",
        // readOnly: editCheckOut,
        // withChange: withChangeDate,
      },
      unit_price: {
        type: "numeric",
        // readOnly: edit,
      },
      room: {
        type: "many2one",
        mode: "card",
        model: "hotel.room",
        recSearch: searchAvailableRooms,
        // readOnly: edit,
      },
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: () => ["department", "=", "accommodation"],
        // readOnly: edit,
      },

      accept: {
        type: "button",
        method: "handleAccept",
        color: "blue",
        // visible: () => !edit,
      },
    },

    webtree: [],
    webform: [
      {
        id: "dates",
        grid: [{ name: "arrival_date" }, { name: "departure_date" }],
        size: [1, 2],
        span: "md:col-span-2",
      },
      { name: "unit_price" },
      { name: "overbooking" },
      { name: "product" },
      { name: "room" },

      { name: "accept", colspan: "md:col-span-2" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
